// extracted by mini-css-extract-plugin
export var button = "_i5-0";
export var donut = "_i5-1";
export var donutFill = "_i5-3";
export var donutTrack = "_i5-2";